import React from "react";

// Fin du questionnaire pour un allocataire orienté vers le Département.
const LandingCD = () => {
  return (
    <div className="etat-final" role="status">
      <div>
        <img className="etat-final__logo" src="/assets/logo-cd.png" alt="Département de La Réunion" />
        <h2 className="etat-final__titre">Votre questionnaire est terminé</h2>
        <p>Votre inscription à France Travail est finalisée.</p>
        <p>
          <strong>
            Vous serez prochainement contacté(e) par un agent du Conseil Départemental afin de vous
            proposer un rendez-vous avec le professionnel qui vous accompagnera dans vos démarches
            personnelles et professionnelles.
          </strong>
        </p>
        <p>Ce rendez-vous est obligatoire.</p>
      </div>
    </div>
  );
};

export default LandingCD;
